const translations = {
  en: {
    "I'm reading your accounts now": "I'm reading your accounts now",
    "Your first read is ready in a few minutes. Turn on notifications and I'll send it the moment it's done.":
      "Your first read is ready in a few minutes. Turn on notifications and I'll send it the moment it's done.",
    "Turn on notifications": "Turn on notifications",
    "Got it": "Got it",
  },
  "zh-tw": {
    "I'm reading your accounts now": "我正在讀取你的帳戶",
    "Your first read is ready in a few minutes. Turn on notifications and I'll send it the moment it's done.":
      "你的第一份分析將在幾分鐘後準備就緒。開啟通知，完成後我會第一時間傳送給你。",
    "Turn on notifications": "開啟通知",
    "Got it": "我知道了",
  },
};

export default translations;
